export { default } from './CurrentUserDetail';
